module.exports = __webpack_public_path__ + "static/media/Source Info.b9ee4a3c.txt";